import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Select, MenuItem, FormControl } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import logo from './assets/logo.png'; // Import the logo image
import './Navbar.css';
import { TbDeviceAnalytics } from "react-icons/tb";
import { ImPriceTags } from "react-icons/im";
import { IoIosHome } from "react-icons/io";
import { IoCalendar, IoGlobeOutline } from "react-icons/io5";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMobilePortal, setIsMobilePortal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState('/');

  useEffect(() => {
    const handleResize = () => {
      // Detect mobile device via user agent OR if the viewport width is under 768px
      const mobileDevice = /Mobi|Android/i.test(navigator.userAgent);
      setIsMobile(mobileDevice || window.innerWidth <= 785);
      setIsMobilePortal(mobileDevice); // Adjust this logic if needed
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setSelectedOption(location.pathname);
  }, [location]);

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
    navigate(e.target.value);
  };

  // Render navbar links based on conditions:
  // 1. If mobile AND isMobilePortal
  // 2. If mobile BUT NOT isMobilePortal
  // 3. Otherwise (desktop)
  const renderNavbarLinks = () => {
    if (isMobile) {
      if (isMobilePortal) {
        // Mobile device and mobile portal
        return (
          <FormControl
            variant="outlined"
            className="navbar-dropdown"
            style={{ marginTop: '2%' }}
          >
            <Select
              value={selectedOption}
              onChange={handleSelectChange}
              displayEmpty
              sx={{
                width: '100%',
                height: '45px',
                color: 'white',
                fontWeight: 'bold',
                fontFamily: 'Roboto, sans-serif',
                backgroundColor: 'rgba(128, 128, 128, 0.3)',
                '& .MuiSelect-select': {
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontFamily: 'Roboto, sans-serif',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
              }}
            >
              <MenuItem value="/" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <IoIosHome style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Home
              </MenuItem>
              <MenuItem value="/pricing" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <ImPriceTags style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Pricing
              </MenuItem>
             
              <MenuItem value="/websites" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <IoGlobeOutline style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Websites
              </MenuItem>
              <MenuItem value="/contact" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <IoCalendar style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Contact
              </MenuItem>
              {/* <MenuItem value="/portal" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                Portal
              </MenuItem> */}
              <MenuItem value="/portal" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <TbDeviceAnalytics style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Client Portal
              </MenuItem>


            </Select>
          </FormControl>
        );
      } else {
        // Mobile device but NOT mobile portal
        return (
          <FormControl
            variant="outlined"
            className="navbar-dropdown"
            style={{ marginTop: '2%' }}
          >
            <Select
              value={selectedOption}
              onChange={handleSelectChange}
              displayEmpty
              sx={{
                width: '100%',
                height: '45px',
                color: 'white',
                fontWeight: 'bold',
                fontFamily: 'Roboto, sans-serif',
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Different background for this condition
                '& .MuiSelect-select': {
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: 'white',
                  fontWeight: 'bold',
                  fontFamily: 'Roboto, sans-serif',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'white',
                },
              }}
            >
              <MenuItem value="/" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <IoIosHome style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Home
              </MenuItem>
              <MenuItem value="/pricing" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <ImPriceTags style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Pricing
              </MenuItem>

              <MenuItem value="/websites" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <IoGlobeOutline style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Websites
              </MenuItem>
              <MenuItem value="/contact" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <IoCalendar style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Contact
              </MenuItem>
              {/* <MenuItem value="/portal" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                Portal
              </MenuItem> */}
              <MenuItem value="/portal" style={{ textAlign: 'center', color: 'black', fontFamily: 'regular' }}>
                <TbDeviceAnalytics style={{ marginRight: '10px', color: '#86BBD8' }} size={24} />
                Client Portal
              </MenuItem>
            </Select>
          </FormControl>
        );
      }
    } else {
      // Neither mobile condition: Desktop view
      return (
        <ul className="navbar-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/pricing">Pricing</Link></li>
          <li><Link to="/websites">Websites</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          {/* <li>
            <Link to="/hurricaneRelief">
              Hurricane Relief Fund
              <FavoriteIcon style={{ marginBottom: '-5px', marginLeft: '5px', color: 'red' }} />
            </Link>
          </li> */}
          <li><Link to="/portal" className="special-button">Client Portal</Link></li>
        </ul>
      );
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Logo" className="logo-img" />
        </Link>
      </div>
      {renderNavbarLinks()}
    </nav>
  );
};

export default Navbar;
